import styled, { css } from 'styled-components';
export const TableHead = styled.thead `
  height: 100%;
`;
export const HeaderCell = styled.th `
  font-weight: 700;
  line-height: 24px;
  height: 100%;
`;
export const FooterCellElement = styled.th `
  font-weight: 700;
  line-height: 24px;
`;
export const HeaderCellButton = styled.button `
  /* override normalize.css for line-height */
  line-height: 24px;
  text-align: left;
  border: none;
  background: transparent;
  cursor: pointer;
  font-weight: 700;
  padding: 0px;
  font-size: 16px;
  color: var(--color-on-background);

  &:focus {
    outline: var(--outline);
    outline-offset: 4px;
  }
  &:focus:not(:focus-visible) {
    outline: 0;
  }
  &:focus-visible {
    outline: var(--outline);
    outline-offset: 4px;
  }
`;
export const BorderContainer = styled.div `
  /* 11px is 12px minus borders. */
  padding: 11px 16px;
  height: 100%;
  box-sizing: border-box;
  background: var(--color-surface);
  border-top: 1px solid rgba(25, 25, 25, 0.16);
  border-bottom: 1px solid rgba(25, 25, 25, 0.16);

  /* Ensure empty cells fill its space. This is required to fill
    the background color when header cells is empty. */
  min-height: 48px;
`;
export const FooterBorderContainer = styled(BorderContainer) `
  border-top: none;
`;
export const Cell = styled.td `
  padding: 16px;
  line-height: 1;
  border-bottom: 1px solid rgba(25, 25, 25, 0.16);
`;
export const Row = styled.tr `
  &:hover {
    color: var(--color-primary-variant);
    background: rgba(25, 25, 25, 0.05);
  }
`;
export const Wrap = styled.table `
  font-family: 'Open Sans';
  table-layout: fixed;
  color: var(--color-on-background);
  background-color: white;
  border-collapse: collapse;
  width: 100%;
  font-size: 16px;
  height: fit-content;

  ${({ columns }) => css `
    min-width: ${160 * columns}px;
  `}

  td {
    text-align: left;

    /* Align content to top to get proper alignment when the row content
      is multiline. This will make the single line content of a row to be in
      its initial position when multiline content pushes
      the bottom of the row down. */
    vertical-align: top;
  }

  th {
    text-align: left;
  }
`;
export const TableWrapper = styled.div `
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
`;
export const ChevronContainer = styled.button `
  cursor: pointer;
  background: none;
  border: none;
  width: 48px;
  height: 48px;
  padding: 0px;
  margin: -12px 0px;
  flex-shrink: 0;

  &:focus {
    outline: var(--outline);
    outline-offset: -8px;
  }
  &:focus:not(:focus-visible) {
    outline: 0;
  }
  &:focus-visible {
    outline: var(--outline);
    outline-offset: -8px;
  }

  transition: transform 0.3s;

  &.up {
    transform: rotateX(-180deg);
  }
`;
export const IndentedCellWithChevron = styled(Cell) `
  padding-left: ${(props) => 32 * props.depth}px !important;
`;
export const IndentedCell = styled(Cell) `
  padding-left: ${(props) => 48 * props.depth - 16 * (props.depth - 1)}px !important;
`;
export const IndentedCellWrapper = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const BorderlessRow = styled(Row) `
  border-bottom: none;
`;
